'use client';

import { PatientsProvider } from "@/app/contexts/PatientsContext";

export default function PatientsLayout({ children }: { children: React.ReactNode }) {
    return (
        <PatientsProvider>{children}</PatientsProvider>
    );
}